import type { IUseCase } from 'shared-kernel';
import type { IAuthRepository, ITokenService } from '../../../domain/ports';

export class RefreshTokenUseCase implements IUseCase<void, void> {
  constructor(
    private readonly authRepository: IAuthRepository,
    private readonly tokenService: ITokenService,
  ) {}

  async execute(): Promise<void> {
    // Plus de refresh token côté client à vérifier avant l'appel : il vit dans un cookie
    // httpOnly que le JS ne voit jamais. Le backend répond 401 si le cookie est absent/invalide.
    const response = await this.authRepository.refreshToken();

    if (!response.succes || !response.data) {
      throw new Error('Echec du refresh token');
    }

    this.tokenService.setAccessToken(response.data.tokens.accessToken);
  }
}
